var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"9","height":"7","viewBox":"0 0 9 7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.17773 3.58887L5.42107 0.832206M8.17773 3.58887L5.38113 6.38547M8.17773 3.58887L-2.50731e-06 3.58887","stroke":"#282929"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }